<header class="header-page">
    <section class="col-xl-10 col-sm-9 header-page-title">
        <h1 class="header__page__content__title">
            Dados Cadastrais
        </h1>
    </section>
    <section class="col-xl-2 col-sm-3 header__page__notice" *ngIf="lastModificationDate">
        <p class="header__page__notice__content">
            Última alteração
            <br>
            cadastral
        </p>
        <p class="header__page__notice__data">
            {{lastModificationDate | date:'dd/MM/yyyy'}}
        </p>
    </section>
</header>
<main class="main__content">
    <section class="main__content__form">
        <form class="col-xl-12 col-lg-12 col-md-12 col-sm-12 content__form" [formGroup]="formGroup">
            <div class="col-xl-6 p-0">
                <label class="content__form__title__label">Selecione quem deseja consultar</label>
                <ng-select [items]="this.beneficiaries" bindLabel="name" bindValue="id"
                    placeholder="Selecione um beneficiário" [clearable]="false" formControlName="personCpf"
                    (close)="alteraDadoUsuario()">
                </ng-select>
            </div>
        </form>
    </section>
    <section class="text-center">
        <div class="content-usuario-login-images">
            <img class="img-filter" alt="Sem Foto de Perfil" [src]="imagem"
                onError="this.src = '../../../../assets/img/jpg/no-user.jpg'" src="" />
            <img class="watermarked" alt="Editar Foto Perfil" src="../../../../assets/img/jpg/change-img-marcadagua.jpg"
                (click)="uploadImg()" />
        </div>
        <div>
            <h5></h5>
        </div>
    </section>
    <blockquote class="col-12 aviso-ppe">
        Atenção Participante! Faça <a class="link-ppe" [routerLink]="['/solicitacao-declaracao-ppe']">aqui</a> sua
        declaração de pessoa politicamente exposta - PPE
    </blockquote>
    <section class="main__content__tabs">
        <mat-tab-group dynamicHeight (selectedTabChange)="tabClicada($event)">
            <mat-tab label="Dados Pessoais">
                <div class="main__content__tabs__dados">
                    <form class="form form-horizontal" [formGroup]="formData" (ngSubmit)="updateData()">
                        <div class="form-body row">
                            <div class="col-12 col-sm-6 col-md-4 mb-3">
                                <label class="label-form">Nome</label>
                                <input class="form-control input-form" formControlName="name"
                                    [attr.disabled]="formDataEdit ? null : ''" maxlength="70" (change)="dataChanged()"
                                    (keyup)="inputChanged()" placeholder="Informe seu nome"
                                    style="text-transform:uppercase">
                                <small class="form-text text-muted danger ng-star-inserted"
                                    *ngIf="formData.get('name')?.touched && formData.get('name')?.invalid">
                                    O campo Nome é obrigatório!
                                </small>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 mb-3">
                                <label class="label-form">N° da Matrícula</label>
                                <input class="form-control input-form" formControlName="registration"
                                    placeholder="EX: XXX" mask="000.000">
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 mb-3">
                                <label class="label-form">CPF</label>
                                <input class="form-control input-form" formControlName="cpf" mask="XXX.XXX.XXX-XX">
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 mb-3">
                                <label class="label-form">RG</label>
                                <input class="form-control input-form" formControlName="rg" (change)="rgChanged()"
                                    [attr.disabled]="formDataEdit ? null : ''" maxlength="15" (change)="dataChanged()"
                                    (keyup)="inputChanged()" placeholder="XX.XXX.XXX" mask="00.000.000-00">
                                <small class="form-text text-muted danger ng-star-inserted"
                                    *ngIf="formData.get('rg')?.touched && formData.get('rg')?.invalid">
                                    O campo RG é obrigatório!
                                </small>
                            </div>
                            <div class="col-12 col-sm-6 col-md-3 mb-3">
                                <label class="label-form">Órgão Expedidor</label>
                                <input class="form-control input-form" formControlName="rgOrgaoExpeditor"
                                    [attr.disabled]="formDataEdit ? null : ''" maxlength="15"
                                    (keypress)="onlyLetters($event)" (change)="dataChanged()" (keyup)="inputChanged()"
                                    placeholder="XXX-XX" style="text-transform:uppercase">
                                <small class="form-text text-muted danger ng-star-inserted"
                                    *ngIf="formData.get('rgOrgaoExpeditor')?.touched && formData.get('rgOrgaoExpeditor')?.invalid">
                                    O campo Órgão Expedidor é obrigatório!
                                </small>
                            </div>
                            <div class="col-12 col-sm-6 col-md-2 mb-3">
                                <label class="label-form">UF</label>
                                <input class="form-control input-form" formControlName="rgUfOrgaoExpeditor"
                                    [attr.disabled]="formDataEdit ? null : ''" maxlength="2" (change)="dataChanged()"
                                    (keypress)="onlyLetters($event)" (keyup)="inputChanged()" placeholder="XX"
                                    style="text-transform:uppercase">
                                <small class="form-text text-muted danger ng-star-inserted"
                                    *ngIf="formData.get('rgUfOrgaoExpeditor')?.touched && formData.get('rgUfOrgaoExpeditor')?.invalid">
                                    O campo UF é obrigatório!
                                </small>
                            </div>
                            <div class="col-12 col-sm-6 col-md-3 mb-3">
                                <label class="label-form">Data de Expedição</label>
                                <input type="date" class="form-control input-form" formControlName="rgDate"
                                    [attr.disabled]="formDataEdit ? null : ''" [max]="todaysDate"
                                    (change)="dataChanged()" (keyup)="inputChanged()">
                                <small class="form-text text-muted danger ng-star-inserted"
                                    *ngIf="formData.get('rgDate')?.touched && formData.get('rgDate')?.invalid">
                                    O campo Data de Expedição está inválido!
                                </small>
                                <small class="form-text text-muted danger ng-star-inserted"
                                    *ngIf="formData.hasError('rgDate')">
                                    A Data de Expedição deve ser maior que a Data de Nascimento!
                                </small>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 mb-3">
                                <label class="label-form">Data de Nascimento</label>
                                <input type="date" class="form-control input-form" formControlName="birthDate"
                                    [attr.disabled]="formDataEdit ? null : ''" [max]="todaysDate"
                                    (change)="dataChanged()" (keyup)="inputChanged()">
                                <small class="form-text text-muted danger ng-star-inserted"
                                    *ngIf="formData.get('birthDate')?.touched && formData.get('birthDate')?.invalid">
                                    O campo Data de Nascimento está inválido!
                                </small>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 mb-3">
                                <label class="label-form">Sexo</label>
                                <ng-select class="select-disabled" placeholder="Selecione um Sexo" bindValue="desc"
                                    formControlName="gender" [items]="genderList" bindLabel="desc"
                                    (change)="dataChanged()" [disabled]="!formDataEdit">
                                </ng-select>
                                <small class="form-text text-muted danger ng-star-inserted"
                                    *ngIf="formData.get('gender')?.touched && formData.get('gender')?.invalid">
                                    O campo Sexo é obrigatório!
                                </small>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 mb-3">
                                <label class="label-form">Nacionalidade</label>
                                <input class="form-control input-form" formControlName="nationality"
                                    [attr.disabled]="formDataEdit ? null : ''" maxlength="50" (change)="dataChanged()"
                                    (keypress)="onlyLetters($event)" (keyup)="inputChanged()"
                                    placeholder="Informe sua Nacionalidade" style="text-transform:uppercase">
                                <small class="form-text text-muted danger ng-star-inserted"
                                    *ngIf="formData.get('nationality')?.touched && formData.get('nationality')?.invalid">
                                    O campo Nacionalidade é obrigatório!
                                </small>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 mb-3">
                                <label class="label-form">Estado Civil</label>
                                <ng-select [items]="maritalStatusList" bindLabel="desc" bindValue="desc"
                                    (change)="dataChanged()" placeholder="Selecione um Estado Civil"
                                    formControlName="maritalStatus" appendTo="body">
                                </ng-select>
                                <small class="form-text text-muted danger ng-star-inserted"
                                    *ngIf="formData.get('maritalStatus')?.touched && formData.get('maritalStatus')?.invalid">
                                    O campo Estado Civil é obrigatório!
                                </small>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 mb-3">
                                <label class="label-form">Nome da Mãe</label>
                                <input class="form-control input-form" formControlName="mother"
                                    [attr.disabled]="formDataEdit ? null : ''" maxlength="70"
                                    style="text-transform:uppercase" (keypress)="onlyLetters($event)"
                                    (change)="dataChanged()" (keyup)="inputChanged()"
                                    placeholder="Informe o nome da sua Mãe">
                                <small class="form-text text-muted danger ng-star-inserted"
                                    *ngIf="formData.get('mother')?.touched && formData.get('mother')?.invalid">
                                    O campo Nome da Mãe é obrigatório!
                                </small>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 mb-3">
                                <label class="label-form">Nome do Pai</label>
                                <input class="form-control input-form" formControlName="father"
                                    style="text-transform:uppercase" (keypress)="onlyLetters($event)"
                                    [attr.disabled]="formDataEdit ? null : ''" maxlength="70" (change)="dataChanged()"
                                    (keyup)="inputChanged()" placeholder="Informe o nome do seu Pai">
                            </div>
                        </div>
                        <div class="form-actions mb-4" *ngIf="!dependent">
                            <div class="col-12 pl-0 pr-0 form__button__editar float-right">
                                <button class="btn-primary btn col-xl-2 col-lg-3 col-md-4 col-sm-12"
                                    (click)="updateDataEdit(true)" *ngIf="!formDataEdit && !formContactEdit">
                                    Editar Dados</button>
                                <button type="button"
                                    class="btn-outline-danger btn col-xl-2 col-lg-3 col-md-4 col-sm-12"
                                    (click)="updateDataEdit(false)" *ngIf="formDataEdit">
                                    Cancelar Edição</button>
                                <button type="submit"
                                    class="button-primary btn mt-0 ml-sm-1 ml-xl-1 col-xl-2 col-lg-3 col-md-4 col-sm-12"
                                    *ngIf="formDataEdit" [disabled]="dataSolicitationDisable || this.loading">
                                    Solicitar Alteração</button>
                            </div>
                        </div>
                    </form>
                </div>
            </mat-tab>
            <mat-tab label="Contato">
                <div class="main__content__tabs__contato">
                    <form class="form form-horizontal" [formGroup]="formContact" (ngSubmit)="updateContact()">
                        <div class="form-body row">
                            <div class="col-12 col-sm-6 col-md-4 mb-3">
                                <label class="label-form">
                                    CEP
                                    <!-- <a class="form__cep" target="_blank"href="https://buscacepinter.correios.com.br/app/endereco/index.php">Não sei meu CEP</a> -->
                                </label>
                                <input class="form-control input-form" formControlName="cep" maxlength="9"
                                    mask="00000-000" placeholder="XXXXX-XXX"
                                    [attr.disabled]="formContactEdit ? null : ''" (input)="cepChanged()"
                                    (keyup)="inputChanged()">
                                <small class="form-text text-muted danger ng-star-inserted"
                                    *ngIf="formContact.get('cep')?.touched && !formContact.controls['cep'].valid"
                                    [@fadeIn]>
                                    Não foi encontrado o CEP informado
                                </small>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 mb-3">
                                <label class="label-form">Endereço</label>
                                <input class="form-control input-form" formControlName="address" maxlength="70"
                                    [attr.disabled]="formContactEdit ? true : false" (change)="contactChanged()">
                                <small class="form-text text-muted danger ng-star-inserted"
                                    *ngIf="formContact.get('address')?.touched && !formContact.controls['address'].valid">
                                    O campo Endereço é obrigatório!
                                </small>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 mb-3">
                                <label class="label-form">Número</label>
                                <input class="form-control input-form" formControlName="number" maxlength="5"
                                    [attr.disabled]="formContactEdit ? null : ''" (change)="contactChanged()"
                                    autocomplete="off">
                                <small class="form-text text-muted danger ng-star-inserted"
                                    *ngIf="formContact.get('number')?.touched && !formContact.controls['number'].valid">
                                    O campo Número é obrigatório!
                                </small>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 mb-3">
                                <label class="label-form">Complemento</label>
                                <input class="form-control input-form" formControlName="complement" maxlength="70"
                                    [attr.disabled]="formContactEdit ? null : ''" (change)="contactChanged()"
                                    (keyup)="inputChanged()" autocomplete="off">
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 mb-3">
                                <label class="label-form">Bairro</label>
                                <input class="form-control input-form" formControlName="district" maxlength="40"
                                    [attr.disabled]="formContactEdit ? true : false" (change)="contactChanged()">
                                <small class="form-text text-muted danger ng-star-inserted"
                                    *ngIf="formContact.get('district')?.touched && !formContact.controls['district'].valid">
                                    O campo Bairro é obrigatório!
                                </small>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 mb-3">
                                <label class="label-form">Caixa Postal</label>
                                <input class="form-control input-form" formControlName="postalCode" maxlength="70"
                                    [attr.disabled]="formContactEdit ? null : ''" (change)="contactChanged()"
                                    (keyup)="inputChanged()" autocomplete="off">
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 mb-3">
                                <label class="label-form">Município</label>
                                <input class="form-control input-form" formControlName="city"
                                    style="text-transform:uppercase" [attr.disabled]="formContactEdit ? null : ''">
                                <small class="form-text text-muted danger ng-star-inserted"
                                    *ngIf="formContact.get('city')?.touched && !formContact.controls['city'].valid">
                                    O campo Município é obrigatório!
                                </small>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 mb-3">
                                <label class="label-form">UF</label>
                                <input class="form-control input-form" formControlName="state"
                                    [attr.disabled]="formContactEdit ? null : ''" placeholder="Ex: XX"
                                    style="text-transform:uppercase" (keypress)="onlyLetters($event)">
                                <small class="form-text text-muted danger ng-star-inserted"
                                    *ngIf="formContact.get('state')?.touched && !formContact.controls['state'].valid">
                                    O campo UF é obrigatório!
                                </small>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 mb-3">
                                <label class="label-form">País</label>
                                <input class="form-control input-form" formControlName="country"
                                    [attr.disabled]="formContactEdit ? null : ''" style="text-transform:uppercase"
                                    (keypress)="onlyLetters($event)">
                                <small class="form-text text-muted danger ng-star-inserted"
                                    *ngIf="formContact.get('country')?.touched && !formContact.controls['country'].valid">
                                    O campo País é obrigatório!
                                </small>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 mb-3">
                                <label class="label-form">Telefone Celular</label>
                                <input class="form-control input-form" (change)="contactChanged()"
                                    formControlName="personalPhone" placeholder='(DDD) 9XXXX-XXXX'
                                    [attr.disabled]="formContactEdit ? null : ''" (keyup)="inputChanged()"
                                    mask="(XX) XXXXX-XXXX">
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 mb-3">
                                <label class="label-form">Telefone Comercial/Residencial</label>
                                <input class="form-control input-form" (change)="contactChanged()"
                                    formControlName="comercialPhone" placeholder="(XX) XXXX-XXXX"
                                    [attr.disabled]="formContactEdit ? null : ''" (keyup)="inputChanged()"
                                    mask="(XX) XXXX-XXXX">
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 mb-3">
                                <label class="label-form">E-mail</label>
                                <input class="form-control input-form" [attr.disabled]="formContactEdit ? null : ''"
                                    formControlName="email" style="text-transform:uppercase"
                                    placeholder="xxxxxxx@xxxx.com" (change)="contactChanged()" (keyup)="inputChanged()"
                                    type="email">
                                <small class="form-text text-muted danger ng-star-inserted"
                                    *ngIf="formContact.get('email')?.touched && !formContact.controls['email'].valid">
                                    E-mail inválido!
                                </small>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 mb-3">
                                <label class="label-form">E-mail Alternativo</label>
                                <input class="form-control input-form" formControlName="secondaryEmail"
                                    (change)="contactChanged()" placeholder="xxxxxxx@xxxx.com"
                                    style="text-transform:uppercase" type="email"
                                    [attr.disabled]="formContactEdit ? null : ''" (keyup)="inputChanged()">
                            </div>
                            <br>
                            <div class="form-check form-check-inline col-12 py-3" *ngIf="formContactEdit">
                                <input formControlName="replicateDependant" class="form-check-input" type="checkbox"
                                    id="inlineCheckbox1" value="option1">
                                <label class="form-check-label label-form" for="inlineCheckbox1">Incluir alteração de
                                    endereço para dependentes</label>
                            </div>
                        </div>
                        <div class="form-actions mb-4" *ngIf="!dependent">
                            <div class="col-12 pl-0 pr-0 form__button__editar">
                                <button class="btn-primary btn col-xl-2 col-lg-3 col-md-4 col-sm-12"
                                    (click)="updateContactEdit()" *ngIf="!formContactEdit && !formDataEdit">
                                    Editar Dados
                                </button>
                                <button type="button"
                                    class="btn-outline-danger btn col-xl-2 col-lg-3 col-md-4 col-sm-12"
                                    (click)="updateContactEdit()" *ngIf="formContactEdit">
                                    Cancelar Edição
                                </button>
                                <button type="submit"
                                    class="button-primary btn mt-0 ml-sm-1 ml-xl-1 col-xl-2 col-lg-3 col-md-4 col-sm-12"
                                    *ngIf="formContactEdit" [disabled]="contactSolicitationDisable || loading">
                                    Solicitar Alteração
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </mat-tab>
            <mat-tab label="Senha">
                <form class="form form-horizontal" [formGroup]="formPasword" (ngSubmit)="chagePassword()">
                    <section class="form-body row">
                        <div class="col-12 col-sm-6 col-md-4 mb-3">
                            <label class="label-form">Senha antiga</label>
                            <input type="password" class="form-control input-form"
                                [attr.disabled]="formContactEdit ? null : ''" formControlName="senhaAntiga"
                                placeholder="">
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formPasword.get('senhaAntiga')?.touched && formPasword.get('senhaAntiga')?.invalid">
                                Informe a senha atual!
                            </small>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3">
                            <label class="label-form">Nova senha</label>
                            <input type="password" class="form-control input-form"
                                [attr.disabled]="formContactEdit ? null : ''" formControlName="novaSenha"
                                placeholder="">
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formPasword.get('novaSenha')?.hasError('required') && formPasword.get('novaSenha')?.touched"
                                [@fadeIn]>
                                A nova senha é obrigatória.
                            </small>
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formPasword.hasError('passwordMismatch') && formPasword.get('novaSenha')?.touched && formPasword.get('confirmaSenha')?.touched && formPasword.get('confirmaSenha')?.value != null && formPasword.get('confirmaSenha')?.value != ''"
                                [@fadeIn]>
                                As senhas estão diferentes!
                            </small>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3">
                            <label class="label-form">Confirmar nova senha</label>
                            <input type="password" class="form-control input-form"
                                [attr.disabled]="formContactEdit ? null : ''" formControlName="confirmaSenha"
                                placeholder="">
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formPasword.get('confirmaSenha')?.hasError('required') && formPasword.get('confirmaSenha')?.touched"
                                [@fadeIn]>
                                A campo confirmação da senha é obrigatório.
                            </small>
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formPasword.hasError('passwordMismatch') && formPasword.get('novaSenha')?.touched && formPasword.get('confirmaSenha')?.touched && formPasword.get('confirmaSenha')?.value != null && formPasword.get('confirmaSenha')?.value != ''"
                                [@fadeIn]>
                                As senhas estão diferentes!
                            </small>
                        </div>
                    </section>
                    <div class="form-actions ml-1 mb-4">
                        <div class="col-12 pl-0 pr-0 form__button__editar">
                            <button class="btn-primary btn col-xl-2 col-lg-3 col-md-4 col-sm-12"
                                (click)="updatePasswordEdit()" *ngIf="!formPasswordEdit && !formPasswordEdit">
                                Editar Dados
                            </button>
                            <button type="button" class="btn-outline-danger btn col-xl-2 col-lg-3 col-md-4 col-sm-12"
                                (click)="updatePasswordEdit()" *ngIf="formPasswordEdit">
                                Cancelar Edição
                            </button>
                            <button type="submit"
                                class="button-primary btn mt-0 ml-sm-1 ml-xl-1 col-xl-2 col-lg-3 col-md-4 col-sm-12"
                                *ngIf="formPasswordEdit" [disabled]="!formPasword.valid || this.loading">
                                Solicitar Alteração
                            </button>
                        </div>
                    </div>
                </form>
            </mat-tab>
        </mat-tab-group>
    </section>
</main>